import React, { useState, useEffect } from 'react';
import { Row, Col, Tabs, DatePicker, Select, Collapse, Tooltip } from 'antd';
import FileConstants from '../../../../FileConstants';
import SystemUsage from '../../AdminComponents/SystemUsage/SystemUsage';
import moment from 'moment';
import ManagedServices from '../../ManagedServices/ManagedServices';
import { InfoCircleOutlined } from '@ant-design/icons';
import SharedItemUsage from '../../SharedItemUsage/SharedItemUsage';
import SystemUsageSummary from '../../SystemUsageSummary/SystemUsageSummary';

const COMPANY_ID = FileConstants.COMPANY_ID;
const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;
const IS_MS_PROVIDER = FileConstants.isMSProvider;
const MANAGED_CUSTOMER_USERNAME = FileConstants.MANAGED_CUSTOMER_USERNAME;
const MANAGED_COMPANY_ID = FileConstants.MANAGED_COMPANY_ID;
const DATE_FORMAT = 'MM/DD/YYYY';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const CustomerAccountUsage = (props) => {
    const [startDate, setStartDate] = useState(moment().startOf('month').format(DATE_FORMAT));
    const [endDate, setEndDate] = useState(moment().endOf('month').format(DATE_FORMAT));
    const [customerUsername, setCustomerUsername] = useState('');
    const [companyID, setCompanyID] = useState(-1);
    const [accountType, setAccountType] = useState("customer");
    const [dateFilterType, setDateFilterType] = useState('created_on');
    const [tabKey, setTabKey] = useState('usage_details');
    const [collapseKey, setCollapseKey] = useState(["details"]);
    const [displayData, setDisplayData] = useState(true);
    const [totalCount, setTotalCount] = useState([]);
    const [summaryLoader, setSummaryLoader] = useState(true);


    useEffect(() => {
        if (props.account_type == 'admin') {
            setAccountType(props.account_type);
            setCustomerUsername(props.username);
            setCompanyID(props.company_id);
        } else {
            // Show data for selected customer in managed service provider account
            if (IS_MS_PROVIDER && (MANAGED_CUSTOMER_USERNAME != null)) {
                setCustomerUsername(MANAGED_CUSTOMER_USERNAME);
                if (MANAGED_COMPANY_ID != null) {
                    setCompanyID(MANAGED_COMPANY_ID);
                }
            } else {
                if (COMPANY_ID) {
                    setCompanyID(COMPANY_ID);
                } else if (CUSTOMER_USERNAME) {
                    setCustomerUsername(CUSTOMER_USERNAME);
                }
            }
        }

    }, []);

    const onCalenderChange = (date_values) => {
        if (date_values) {
            console.log('date values', date_values)
            if (date_values[0]) {
                setStartDate(date_values[0].format(DATE_FORMAT));
            }
            if (date_values[1]) {
                setEndDate(date_values[1].format(DATE_FORMAT));
            }
        }
    }


    const checkIfDateIsSameMonth = (new_start_date, new_end_date) => {
        if (new_start_date && new_end_date && dateFilterType == 'billing_date') {
            let start_date = moment(new_start_date, DATE_FORMAT);
            let end_date = moment(new_end_date, DATE_FORMAT);
        
            let startOfCurrentMonth = moment().startOf('month').format(DATE_FORMAT)
            let endOfCurrentMonth = moment().endOf('month').format(DATE_FORMAT)
        
            // let isCurrentMonthYearRange = start_date.isSameOrAfter(startOfCurrentMonth, 'day')
            // && end_date.isSameOrBefore(endOfCurrentMonth, 'day');
            let isCurrentMonthYearRange = start_date.isSameOrAfter(startOfCurrentMonth, 'day');
            setDisplayData(!isCurrentMonthYearRange);
        } else {
            setDisplayData(true);
        }
    }
    
    useEffect(() => {
        checkIfDateIsSameMonth(startDate, endDate)
    }, [endDate, startDate, dateFilterType])
   



    const onChangeDateType = (key) => {
        setDateFilterType(key);
    }

    const onChangeTab = (key) => {
        setTabKey(key);
    }

    useEffect(() => {
        if (tabKey == "shared_items" || tabKey == "managed_services") {
            
        }
    }, [tabKey])

    return (
        <>
            <Row className="justify-space-between" style={{ marginTop: "20px", marginBottom: 20 }}>
                <Col span={24} className='justify-space-between'>
                    <Col>
                        <div className='manrope f-24 w-700' style={{ display: 'flex', alignItems: "center" }}>
                            Usage History
                        </div>
                    </Col>
                    <Col lg={10} xl={10} className="justify-in-end">
                        <div className='manrope f-14 black-55' style={{ marginRight: 8 }}>
                            Date Filter
                        </div>
                        <RangePicker size={"large"} defaultValue={[moment(startDate, DATE_FORMAT), moment(endDate, DATE_FORMAT)]}
                            format={DATE_FORMAT} className="date-picker" popupStyle={{ fontFamily: 'Manrope', fontSize: 14, color: "#40a9ff", background: "#e6efff" }} placeholder={['Date (From)', 'Date (To)']}
                            renderExtraFooter={() => <p className='date-footer'><InfoCircleOutlined />&nbsp; {FileConstants.DATE_FILTER_INFO[tabKey]}</p>}
                            value={[moment(startDate, DATE_FORMAT), moment(endDate, DATE_FORMAT)]}
                            onCalendarChange={val => onCalenderChange(val)} />

                        <Select
                            className="manrope f-14 black-55 tree-select-material"
                            placeholder="Filter By Date"
                            onChange={onChangeDateType}
                            defaultValue={"created_on"}
                            defaultActiveFirstOption={true}
                            style={{ width: 160, marginLeft: 10 }}
                            dropdownMatchSelectWidth={false}
                            placement={"bottomRight"}
                            options={accountType == "admin" ? FileConstants.DATE_FILTERS_ADMIN : FileConstants.DATE_FILTERS_CUSTOMER} />

                    </Col>
                </Col>
            </Row>

            <Collapse
                destroyInactivePanel={false}
                defaultActiveKey={collapseKey} style={{ marginTop: 32 }} className="collapse-panel bg-df" ghost
                expandIconPosition={'right'}>
                <Panel
                    forceRender={true}
                    style={{ marginBottom: 10 }}
                    header={<span className="manrope f-16 black-55 w-700">Summary &nbsp; <Tooltip
                        title={<span className='manrope f-14 white'>This summary is only for your Usage.</span>}>
                        <InfoCircleOutlined />
                    </Tooltip></span>}
                    key={"summary"}>
                    <SystemUsageSummary
                        summaryLoader={summaryLoader}
                        setSummaryLoader={setSummaryLoader}
                        totalCount={totalCount}
                        setTotalCount={setTotalCount}
                        display_data={displayData}
                        date_filter_type={dateFilterType}
                        username={customerUsername}
                        company_id={companyID}
                        start_date={startDate}
                        end_date={endDate} />
                </Panel>
                <Panel
                    forceRender={true}
                    style={{ marginBottom: 10 }}
                    header={<span className="manrope f-16 black-55 w-700">Details</span>}
                    key={"details"}>
                    <Tabs onChange={onChangeTab}
                        style={{ marginTop: 20, marginLeft: 10, marginRight: 10 }} defaultActiveKey={['usage_details']} className="product-tab library" tabBarGutter={16} size="large">
                        <TabPane tab={`${IS_MS_PROVIDER && (MANAGED_CUSTOMER_USERNAME != null) ? MANAGED_CUSTOMER_USERNAME + "'s" : "Your"} Usage`} key={"usage_details"} style={{ padding: "10px" }}>
                            <SystemUsage
                                summaryLoader={summaryLoader}
                                totalCount={totalCount}
                                display_data={displayData}
                                date_filter_type={dateFilterType}
                                start_date={startDate}
                                end_date={endDate}
                                username={customerUsername}
                                account_type={accountType}
                                company_id={companyID} />
                        </TabPane>

                        {/* Commenting code for now - might need it later */}
                        {/* <TabPane tab={'Managed Services'} key={"managed_services"} style={{ padding: "10px" }}>
                            <ManagedServices start_date={startDate} end_date={endDate}
                                account_type={accountType}
                                usage_type={companyID == -1 ? "customer" : "company"}
                                data_value={companyID == -1 ? customerUsername : companyID} />
                        </TabPane> */}

                        <TabPane tab={'Shared Items'} key={"shared_items"} style={{ padding: "10px" }}>
                            <SharedItemUsage
                                display_data={displayData}
                                date_filter_type={dateFilterType}
                                start_date={startDate}
                                end_date={endDate}
                                username={customerUsername}
                                account_type={accountType}
                                company_id={companyID} />
                        </TabPane>
                    </Tabs>
                </Panel>
            </Collapse>
        </>
    );

}

export default CustomerAccountUsage;
